module.exports = __webpack_public_path__ + "media/images/footer/iea-3286dc1700fda9ef8c4be98d185265bb.png";